/**
 * Problemas que o verificador encontra. Cada um diz o que está errado e como consertar, num texto
 * que serve a uma pessoa e a uma IA: o relatório inteiro vai para a conversa com "Copiar relatório".
 */
import { MESSAGES, type Lang } from './messages.js';

export type IssueLevel = 'error' | 'warning';

export type Issue = {
  level: IssueLevel;
  /** identificador estável (testes, documentação) */
  code: string;
  message: string;
  /** como consertar */
  fix?: string;
  /** arquivo do pacote e linha (1 em diante) */
  file?: string;
  line?: number;
};

export const hasErrors = (issues: readonly Issue[]): boolean => issues.some((i) => i.level === 'error');

/** Linha (1 em diante) de uma posição do texto. */
export function lineAt(text: string, index: number): number {
  let line = 1;
  for (let i = 0; i < index && i < text.length; i++) if (text.charCodeAt(i) === 10) line += 1;
  return line;
}

/** O relatório em texto, para copiar: erros primeiro, cada um com o conserto. */
export function formatReport(issues: readonly Issue[], title?: string, lang: Lang = 'pt'): string {
  const M = MESSAGES[lang].report;
  const errors = issues.filter((i) => i.level === 'error');
  const warnings = issues.filter((i) => i.level === 'warning');
  const lines: string[] = [];
  lines.push(`${M.title}${title ? ` (${title})` : ''}`);
  lines.push(issues.length === 0 ? M.none : M.count(errors.length, warnings.length));
  for (const issue of [...errors, ...warnings]) {
    const where = issue.file ? ` ${issue.file}${issue.line ? `:${issue.line}` : ''}` : '';
    lines.push('');
    lines.push(`${issue.level === 'error' ? M.error : M.warning}${where} — ${issue.message}`);
    if (issue.fix) lines.push(`  ${M.fix}: ${issue.fix}`);
  }
  if (errors.length > 0) {
    lines.push('');
    lines.push(M.blocked);
  }
  return lines.join('\n');
}
